/**
 * Environment Detection Utilities
 * ✅ DEVELOPMENT: Better environment detection and debugging
 */
export function detectEnvironment() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    const port = typeof window !== 'undefined' ? window.location.port : null;
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');
    const isDevelopment = process.env.NODE_ENV !== 'production' || isLocalhost;
    const isProduction = !isDevelopment;
    // Determine API base URL based on environment
    let apiBaseUrl;
    if (isDevelopment) {
        apiBaseUrl = process.env.API_BASE_URL || 'http://localhost:3030/api';
    }
    else {
        apiBaseUrl = process.env.API_BASE_URL || '/api';
    }
    return {
        isProduction,
        isDevelopment,
        isLocalhost,
        hostname,
        port,
        protocol,
        apiBaseUrl
    };
}
export function logEnvironmentInfo() {
    const env = detectEnvironment();
    console.group('🌍 Environment Information');
    console.log(`📍 Hostname: ${env.hostname}`);
    console.log(`🔌 Port: ${env.port || 'N/A'}`);
    console.log(`🔒 Protocol: ${env.protocol}`);
    console.log(`🏠 Is Localhost: ${env.isLocalhost ? '✅' : '❌'}`);
    console.log(`🔧 Is Development: ${env.isDevelopment ? '✅' : '❌'}`);
    console.log(`🚀 Is Production: ${env.isProduction ? '✅' : '❌'}`);
    console.log(`🌐 API Base URL: ${env.apiBaseUrl}`);
    console.groupEnd();
    // CSP debugging
    if (env.isDevelopment) {
        console.log('🔐 CSP: Development mode - localhost connections allowed');
        console.log('💡 Tip: CSP will be stricter in production');
    }
    else {
        console.log('🔐 CSP: Production mode - strict security policy');
    }
}
export function getCSPConnectSrc() {
    const env = detectEnvironment();
    if (env.isDevelopment) {
        return [
            "'self'",
            "http://localhost:*",
            "ws://localhost:*",
            "wss://localhost:*",
            "http://127.0.0.1:*",
            "https://eckpunkt.app",
            "https://*.eckpunkt.app",
            "https://daluigi.app",
            "https://*.daluigi.app",
        ];
    }
    else {
        return [
            "'self'",
            "https://eckpunkt.app",
            "https://*.eckpunkt.app",
            "https://tasti-o.app",
            "https://*.tasti-o.app",
            "https://daluigi.app",
            "https://*.daluigi.app"
        ];
    }
}
export function getCSPImageSrc() {
    const env = detectEnvironment();
    const baseSources = [
        "'self'",
        "data:",
        "blob:",
        "https://eckpunkt.app",
        "https://*.eckpunkt.app",
        "https://tasti-o.app",
        "https://*.tasti-o.app"
    ];
    if (env.isDevelopment) {
        baseSources.push("http://localhost:*", "http://127.0.0.1:*");
    }
    return baseSources;
}
// Export for use in main.ts
export function initializeEnvironment() {
    const env = detectEnvironment();
    // Set global environment info
    if (typeof window !== 'undefined') {
        window.__ENV__ = env;
    }
    // Log environment info in development
    if (env.isDevelopment) {
        logEnvironmentInfo();
    }
    return env;
}
